import * as preact from "preact";

import * as transliterations from "transliterations";

interface Props {
  language: string;
  text: string;
  parentheses?: boolean;
}

interface State {
  transliteration?: string;
}

class TransliterationView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};

    transliterations.show(this.props.language).then((showTransliterations) => {
      if (showTransliterations) {
        this.fetchTransliteration();
      }
    });
  }

  fetchTransliteration = async () => {
    this.setState({
      transliteration: await transliterations.fetch(
        this.props.language,
        this.props.text
      ),
    });
  };

  render() {
    if (!this.state.transliteration) {
      return null;
    }
    return (
      <span class="transliteration">
        {this.props.parentheses ? "(" : ""}
        {this.state.transliteration}
        {this.props.parentheses ? ")" : ""}
      </span>
    );
  }
}

export default TransliterationView;
